var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-dropdown",
    { attrs: { overlayClassName: "system-change-drop-overlay" } },
    [
      _c(
        "span",
        { staticClass: "right-content__action" },
        [
          _c("icon-font", { attrs: { type: "gb-icon-moudle" } }),
          _c("span", { staticStyle: { padding: "0 8px 0 4px" } }, [
            _vm._v(_vm._s(_vm.currentName))
          ]),
          _c("a-icon", { attrs: { type: "down" } })
        ],
        1
      ),
      _c(
        "a-menu",
        {
          staticStyle: { top: "-4px" },
          attrs: { slot: "overlay" },
          slot: "overlay"
        },
        _vm._l(
          _vm.systems
            .filter(function(find) {
              return (
                _vm.systemCode !== find.systemCode && this$1.isPassSystem(find)
              )
            })
            .concat([_vm.selmuchSystem]),
          function(system) {
            return _c(
              "a-menu-item",
              {
                key: system.systemCode,
                on: {
                  click: function($event) {
                    return _vm.toSystem(system)
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      _vm.sticon[system.systemCode] ||
                      _vm.sticon["EASY_BOOSTER"]
                  }
                }),
                _vm._v(" " + _vm._s(system.systemName) + " ")
              ]
            )
          }
        ),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }